import { Amplify, Auth, I18n } from 'aws-amplify'

import { translations } from '@aws-amplify/ui-react'

I18n.putVocabularies(translations)
I18n.putVocabularies({
  pt: {
    'Enter your Password': 'Insira sua senha',
    'Enter your Username': 'Insira seu usuário',
    'Enter your username': 'Email',
    'Incorrect username or password.': 'Usuário e/ou senha inválidos.',
    'Reset Password': 'Esqueceu sua senha?',
    Username: 'Email',
  },
})
I18n.setLanguage('pt')

Amplify.configure({
  ssr: true,
})

// Function to get the current domain dynamically
function getCurrentDomain(): string {
  // In development, always use localhost
  // if (process.env.NODE_ENV === 'development') {
  //   return 'localhost'
  // }

  // Check if we're in a browser environment
  if (typeof window !== 'undefined' && window.location) {
    const hostname = window.location.hostname

    // Handle Vercel preview domains (e.g., *.vercel.app, *.vercel.com)
    if (hostname.includes('vercel.app')) {
      return hostname
    }

    if (hostname.includes('localhost')) {
      return 'localhost'
    }

    // Handle specific known domains
    if (hostname.includes('.s.motrix.global')) {
      return 's.motrix.global'
    }

    if (hostname.includes('.d.motrix.global')) {
      return 'd.motrix.global'
    }

    if (hostname.includes('motrixeducacao.com.br')) {
      return 'motrixeducacao.com.br'
    }

    if (hostname.includes('.motrix.global')) {
      return 'motrix.global'
    }

    // For any other domain, use the current hostname
    return hostname
  }

  // Fallback for SSR or when window is not available
  // Use environment variables as fallback
  switch (process.env.APP_ENV) {
    case 'production':
      return 'motrix.global'
    case 'staging':
      return 's.motrix.global'
    default:
      return 'd.motrix.global'
  }
}

const domain = getCurrentDomain()

Auth.configure({
  cookieStorage: {
    domain,
    expires: 365,
    path: '/',
    secure: process.env.NODE_ENV === 'production',
  },
  region:
    process.env.AWS_REGION ??
    (import.meta as { env?: { AWS_REGION?: string } }).env?.AWS_REGION,
  userPoolId:
    process.env.COGNITO_USER_POOL_ID ??
    (import.meta as { env?: { COGNITO_USER_POOL_ID?: string } }).env
      ?.COGNITO_USER_POOL_ID,

  userPoolWebClientId:
    process.env.COGNITO_CLIENT_ID ??
    (import.meta as { env?: { COGNITO_CLIENT_ID?: string } }).env
      ?.COGNITO_CLIENT_ID,
})
